module.exports = __webpack_public_path__ + "img/ai_teacher_Chloe.cea40584.png";